<!-- eslint-disable @angular-eslint/template/cyclomatic-complexity -->

<div class="comparison__container">
  @if (selectedProduct) {
    <ng-container>
      <div class="comparison__selector">
        <i class="fas fa-chevron-down"></i>
        <select type="text" aria-label="Series" [(ngModel)]="selectedJebbitID" (change)="selectProduct($event)">
          @for (product of products; track selectedTracker($index, product)) {
            <option [value]="product.fields.jebbitId">
              {{ product.fields.displayNamePrePurchaseProductList }}
            </option>
          }
        </select>
      </div>

      <div class="comparison__body">
        <div class="comparison__image_block">
          <img
            alt="info icon"
            class="comparison__preview_image"
            [src]="selectedProduct.fields.mainAsset.fields.asset.fields.file.url"
          />
        </div>

        @for (
          entry of selectedProduct.fields.prePurchaseComparePoints;
          track selectedTracker(entryIndex, entry);
          let entryIndex = $index
        ) {
          @if (!entry.fields.accessories || (entry.fields.accessories && !isHubPage)) {
            <div
              [class]="'comparison__entry comparison__entry-' + entryIndex"
              [ngClass]="{
                comparison__entry_accesories: entry.fields.accessories,
                'comparison__entry-modes': entry.fields.modes,
              }"
              [ngStyle]="{ height: this.titleMaxHeights[entryIndex] + 'px' }"
            >
              @if (!entry.fields.accessories) {
                <div class="comparison__icon_wrapper">
                  @if (entry.fields.image) {
                    <img
                      class="comparison__entry-image"
                      aria-hidden="true"
                      [alt]="entry.fields.text"
                      [src]="parseImageUrl(entry.fields.image)"
                    />
                  }
                </div>
              }
              <div class="comparison__inner_box">
                @if (entry.fields.text) {
                  <div class="comparison__text_entry" [ngClass]="!isHubPage ? 'comparison__text_entry__extend' : ''">
                    <div [innerHTML]="entry.fields.text"></div>
                    @if (entry.fields._tooltipHTML) {
                      <ng-container>
                        @if (index === 0 && isMobile) {
                          <div
                            appTooltip="{{ entry.fields._tooltipHTML }}"
                            [tooltipPosition]="'top-left'"
                            [tooltipClass]="index === 0 && isMobile ? 'first-tooltip' : ''"
                          >
                            <img
                              alt="info icon"
                              width="17"
                              height="19"
                              [src]="'assets/images/recommeded-brushes/info_icon.svg' | staticFileHash"
                            />
                          </div>
                        }
                        @if (index !== 2 && !isMobile) {
                          <div appTooltip="{{ entry.fields._tooltipHTML }}" [tooltipPosition]="'top'">
                            <img
                              alt="info icon"
                              width="17"
                              height="19"
                              [src]="'assets/images/recommeded-brushes/info_icon.svg' | staticFileHash"
                            />
                          </div>
                        }
                        @if (index === 2 || (isMobile && index === 1)) {
                          <div
                            appTooltip="{{ entry.fields._tooltipHTML }}"
                            [tooltipPosition]="'top-right'"
                            [tooltipClass]="'last-tooltip'"
                          >
                            <img
                              alt="info icon"
                              width="17"
                              height="19"
                              [src]="'assets/images/recommeded-brushes/info_icon.svg' | staticFileHash"
                            />
                          </div>
                        }
                      </ng-container>
                    }
                  </div>
                }
                @if (entry.fields.modes && displayModes && !isHubPage) {
                  <ng-container>
                    <div class="comparison__modes">
                      <ul>
                        @for (mode of entry.fields.modes; track mode) {
                          <li>
                            <img [src]="getModeImage(mode.fields.mode)" [alt]="mode.fields.name" />
                            <div class="comparison__modes-content" [innerHTML]="getModeContent(mode.fields.mode)"></div>
                          </li>
                        }
                      </ul>
                    </div>
                  </ng-container>
                }
                @if (entry.fields.accessories) {
                  <div class="comparison__accessories-content">
                    @if (!displayAccesories && index === 1 && !isHubPage) {
                      <ng-container>
                        <div
                          class="accesories_text"
                          aria-hidden="true"
                          (click)="showAccesories(true)"
                          (keyup)="showAccesories(true)"
                        >
                          <svg class="comparison__icon" viewBox="0 0 10 10" role="img" title="icon-1" aria-label=" ">
                            <path d="M10 5.5H5.5V10h-1V5.5H0v-1h4.5V0h1v4.5H10v1z" />
                          </svg>
                          <span i18n="@@product.showAccesories" class="comparison__accesories_text">Show accesories</span>
                        </div>
                      </ng-container>
                    }
                    @if (displayAccesories && !isHubPage) {
                      <ng-container>
                        <ul class="comparison__accessories">
                          <li [innerHTML]="getAccesoriesHTML(entry.fields.accessories)"></li>
                        </ul>
                        @if (index === 1) {
                          <div class="accesories_text" aria-hidden="true" (click)="showAccesories(false)">
                            <svg class="comparison__icon" viewBox="0 0 6 6" role="img" title="icon-1" aria-label=" ">
                              <rect x="0" y="2.5" width="6" height="1" />
                            </svg>
                            <span i18n="@@product.hideAccesories" class="comparison__accesories_text">Hide accesories</span>
                          </div>
                        }
                      </ng-container>
                    }
                  </div>
                }
              </div>
              @if (entry.fields.modes && index === 1 && !isHubPage) {
                <ng-container>
                  @if (!displayModes) {
                    <div class="accesories_text" aria-hidden="true" (click)="showModes(true)" (keyup)="showModes(true)">
                      <svg class="comparison__icon" viewBox="0 0 10 10" role="img" title="icon-1" aria-label=" ">
                        <path d="M10 5.5H5.5V10h-1V5.5H0v-1h4.5V0h1v4.5H10v1z" />
                      </svg>
                      <span i18n="@@product.seeMore" class="comparison__accesories_text">See more</span>
                    </div>
                  }
                  @if (displayModes) {
                    <div class="accesories_text" aria-hidden="true" (click)="showModes(false)" (keyup)="showModes(false)">
                      <svg class="comparison__icon" viewBox="0 0 6 6" role="img" title="icon-1" aria-label=" ">
                        <rect x="0" y="2.5" width="6" height="1" />
                      </svg>
                      <span i18n="@@product.seeLess" class="comparison__accesories_text">See less</span>
                    </div>
                  }
                </ng-container>
              }
            </div>
          }
        }

        <!-- THIS HAS BEEN ASKED TO BE HIDEN FOR NOW, UNTILL CLIENT FUTHER NOTICE : https://support.scalefast.ninja/issues/149771 -->
        <!-- <a class="btn btn-primary comparison__item_button" [ngClass]="{'disabled' : !selectedProductEAN }" [routerLink]="['/products']" [queryParams]="{ean: selectedProductEAN}" i18n="@@product.addToCart">
        Add to cart
      </a> -->
        @if (bazaarvoiceReviews) {
          <div class="comparison__rating_element">
            <div class="comparison__star_image">
              <img
                class="comparison__star_image"
                alt="Recommended brushes"
                [src]="'assets/images/recommeded-brushes/star.png' | staticFileHash"
              />
            </div>
            <div class="comparison__review" tabindex="0">
              <q> {{ selectedProduct.fields.prePurchaseCustomerReview }}</q>
            </div>

            <div class="comparison__bazaarvoice_element">
              <p class="comparison__bazaarvoice_title" i18n="@@product.customersReview">CUSTOMERS REVIEW</p>
              <hr />
              <app-bazaarvoice [bvProductId]="selectedProduct | extractBazaarvoiceID: 'JebbitProduct'" [isInline]="true" />
            </div>
          </div>
        }
      </div>
    </ng-container>
  }
</div>
